import { Tabs } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'

import { REPORT_LIST, reportUrl } from '../Configs/reportList'

/**
 * Вкладки між звітами (К-03, заміна `TopMenu` легасі): той самий перелік, що
 * й на `/report`. Перехід зберігає `?from=&to=` — період не скидається.
 */
export const ReportTabs = ({ activeKey }: { activeKey: string }) => {
    const navigate = useNavigate()
    const { search } = useLocation()

    return (
        <Tabs
            activeKey={activeKey}
            items={REPORT_LIST.map((item) => ({ key: item.key, label: item.title }))}
            onChange={(key) => {
                const item = REPORT_LIST.find((report) => report.key === key)

                if (item) navigate(`${reportUrl(item)}${search}`)
            }}
        />
    )
}
